import React, { forwardRef } from "react";

import { PrintProps } from "./Print.types";

import "./Print.scss";

const Print = forwardRef<HTMLDivElement, PrintProps>(({ children }, ref) => {
  return (
    <div ref={ref} className="mp-templates-print--main">
      {children}
    </div>
  );
});

export default Print;
